/**
 * notify:
 * this.$notify(msg,type)
 * msg: 提示信息 可选 默认 '成功'
 * type: 消息类型(success error warning) 可选 默认 success
 */
import Vue from 'vue'
import NotifyComponent from './Notification'

const NotifyConstructor = Vue.extend(NotifyComponent)
let instance
let instances = []

const Notification = function (msg, type) {
  instance = new NotifyConstructor()
  instance.vm = instance.$mount()
  // 默认显示成功类型
  instance.msg = msg || '成功'
  instance.type = type || 'success'

  if (instances.length) {
    instances.forEach(instance => {
      document.body.removeChild(instance.vm.$el)
    })
    instances = []
  }
  document.body.appendChild(instance.vm.$el)
  setTimeout(() => {
    if (instances.length) {
      document.body.removeChild(instance.vm.$el)
    }
    instances = []
  }, 1200) // 默认显示1200ms

  instances.push(instance)
  return instance.vm
}

export default Notification


// WEBPACK FOOTER //
// ./src/plugins/notification/index.js